export default __webpack_public_path__ + "static/media/TagsIcon.efe48f21.svg";